import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiTelegramBotConnection } from '@app/packages/api/v2/types/entities'
import type { PostTelegramBotConnectionsRequest } from '@app/packages/api/v2/types/params'

export const getTelegramBotConnections = () =>
  createApiAction('getTelegramBotConnections', dispatch =>
    dispatch<{ data: ApiTelegramBotConnection[] }>({ method: 'GET', endpoint: '/api/v2/telegram_bot_connections' })
  )

export const postTelegramBotConnections = (request: PostTelegramBotConnectionsRequest) =>
  createApiAction('postTelegramBotConnections', dispatch =>
    dispatch<{ data: ApiTelegramBotConnection }>({ method: 'POST', endpoint: '/api/v2/telegram_bot_connections', body: JSON.stringify(request) })
  )

export const deleteTelegramBotConnections = (id: string) =>
  createApiAction('deleteTelegramBotConnections', dispatch =>
    dispatch<unknown>({ method: 'DELETE', endpoint: urlEscaped`/api/v2/telegram_bot_connections/${id}` })
  )
